<template>
  <div
    class="rat-mascot-chat-row"
    :class="rowClass"
  >
    <div
      class="rat-mascot-chat-bubble rat-mascot-mascot-only-bubble rat-mascot-glass-card"
      :class="bubbleClass"
      role="article"
      :aria-label="message.role === 'user' ? 'Your message' : 'Assistant reply'"
    >
      <div v-if="message.role === 'assistant'" class="rat-mascot-reply-head">
        <p class="rat-mascot-msg-card__label">{{ agentDisplayName }}</p>
        <button
          v-if="showReplay"
          type="button"
          class="rat-mascot-reply-head__replay"
          title="Replay read aloud"
          aria-label="Replay read aloud"
          @click.stop="$emit('replay')"
        >
          <span aria-hidden="true">🔊</span>
        </button>
      </div>
      <p v-else class="rat-mascot-msg-card__label rat-mascot-msg-card__label--outgoing">You</p>

      <AssistantReplyBody
        v-if="message.role === 'assistant'"
        :content="message.content"
        :formatted="message.formatted"
      />
      <p
        v-else
        class="rat-mascot-mascot-only-bubble__text rat-mascot-mascot-only-bubble__text--message-body"
        :class="{ 'rat-mascot-chat-msg--pending': message.pending }"
      >
        {{ message.content }}
      </p>
    </div>
  </div>
</template>

<script>
import { parseAssistantReply } from '@/utils/assistantReplyFormat';
import AssistantReplyBody from '@/components/AssistantReplyBody.vue';

export default {
  name: 'AssistantMascotChatMessage',
  components: { AssistantReplyBody },
  props: {
    message: {
      type: Object,
      required: true,
    },
    agentDisplayName: {
      type: String,
      default: 'ANNA AGENT',
    },
    showReplay: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['replay'],
  computed: {
    rowClass() {
      return this.message.role === 'user'
        ? 'rat-mascot-chat-row--outgoing'
        : 'rat-mascot-chat-row--incoming';
    },
    bubbleClass() {
      return this.message.role === 'user'
        ? 'rat-mascot-glass-card--user'
        : 'rat-mascot-glass-card--reply';
    },
    formatted() {
      if (this.message.role !== 'assistant') {
        return { hasStructuredItems: false, plainParts: [] };
      }
      return this.message.formatted || parseAssistantReply(this.message.content);
    },
  },
};
</script>
